import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

export default new Vuex.Store({
    //This needs to be split into vuex modules (online/walkin)
    state: {
        currentDemographic: {
            formData: {},
            isValid: false
        },
        currentOwnerDemographic: {
            formData: {},
            isValid: false
        },
        currentPetDemographic: {
            formData: { petApproxAgeType: 'years' },
            isValid: false
        },
        currentChiefComplaint: {
            formData: {},
            isValid: false
        },
        currentContactInfo: {
            formData: { optIn: '3' },
            isValid: false
        },
        currentOwnerContactInfo: {
            formData: {},
            isValid: false
        },
        currentCustomQuestions: {
            formData: {},
            isValid: false
        },
        currentClientDepartments: {
            formData: {},
            isValid: false
        },
        currentStep: 0,
        showGlassbreak: false,
        showInstructions: false,
        currentModel: null,
        isLoading: false,
        isSubmitLoading: false,
        isError: false,
        isTimePassed: false,
        responseReceived: false,
        isWalkin: false,
        isOnline: false,
        isOnlineValid: false,
        onlineOptionSelected: 'Phone',
        onlineInput: null,
        onlineInputTemp: null,
        onlineFailedAttempts: 0,
        onlineDob: null,
        showOnlineFailedAttempts: false,
        onlineMultipleBookings: false,
        reservationConfirmationNumber: null,
        jotFormRedirectUrl: null,
        reservationId: null,
        messageHeadline: null,
        messageContent: null,
        walkinNotSupported: false,
        clientNotFound: false,
        clientError: null,
        serverError: null,
        inputFocus: false,
        settingsApi: '/api/walkin',
        buildRev: '',
        previousRequestCancelToken: null,
        parentClientId: null,
        isFirstAvailableRequestDone: false,
        isReservationSubmitted: false,
        parentOrigin: '',
        unLockObject: {},
        isPatientCountLimitExceeded: false,
        ezyvet: {
            contacts: [],
            contact: null,
            animals: [],
            animal: null,
            addNewAnimal: false
        },
        loadingContacts: false,
    },
    mutations: {
        updateEzyvetContacts(state, contacts) {
            state.ezyvet.contacts = contacts ?? [];
        },
        updateEzyvetAnimals(state, animals) {
            state.ezyvet.animals = animals ?? [];
        },
        updateCurrentModel(state, model) {
            state.currentModel = model;
        },
        updateFirstAvailableTime(state, model) {
            console.log(state);
            console.log(model);
            //state.currentModel.availableTime = model;
        },
        resetWalkinForm(state) {
            state.currentChiefComplaint = {
                formData: {},
                isValid: false
            };
            state.currentDemographic = {
                formData: {},
                isValid: false
            };
            state.currentPetDemographic = {
                formData: { petApproxAgeType: 'years' },
                isValid: false
            };
            state.currentContactInfo = {
                formData: { optIn: '' },
                isValid: false
            };
            state.currentOwnerContactInfo = {
                formData: {},
                isValid: false
            };
            state.currentCustomQuestions = {
                formData: {},
                isValid: false
            };
            state.currentClientDepartments = {
                formData: {},
                isValid: false
            };
            state.currentStep = 0;
            state.isWalkin = false;
            state.messageHeadline = null;
            state.messageContent = null;
            state.reservationConfirmationNumber = null;
            state.reservationId = null;
            state.inputFocus = false;
            state.isFirstAvailableRequestDone = false;
            state.isReservationSubmitted = false;
            state.isPatientMaxLimitExceeded = false;
        },
        resetOnlineForm(state) {
            state.onlineOptionSelected = 'Phone';
            state.onlineFailedAttempts = 0;
            state.onlineMultipleBookings = false;
            state.showOnlineFailedAttempts = false;
            state.onlineInput = null;
            state.onlineInputTemp = null;
            state.onlineDob = null;
        }
    },
    actions: {
        fetchModel(ctx, clientId) {
            ctx.state.isLoading = true;
            ctx.state.clientNotFound = false;
            ctx.state.walkinNotSupported = false;
            ctx.state.clientError = null;
            ctx.state.serverError = null;
            axios.get(`${ctx.state.settingsApi}/settings/${clientId}`).then(r => {
                if (r.headers.buildrev)
                    ctx.state.buildRev = r.headers.buildrev;
                if (!r.data.availableTime && r.data.settings.clientType !== 'GROUP')
                    ctx.state.walkinNotSupported = true;
                if (r.data.availableTime && !r.data.availableTime.clientAvailableTimeId && r.data.settings.clientType !== 'GROUP')
                    ctx.state.walkinNotSupported = true;
                ctx.commit('updateCurrentModel', r.data);
                if (r.data.settings.clientType === 'GROUP')
                    ctx.state.parentClientId = r.data.settings.clientId;
            }).catch(error => {
                if (error.response.status === 404)
                    ctx.state.clientNotFound = true;
                else if (error.response.status === 500) {
                    if (error.response.data)
                        ctx.state.serverError = error.response.data;
                    else
                        ctx.state.serverError = error.message;
                } else
                    ctx.state.clientError = error.message;
            }).finally(() => ctx.state.isLoading = false);
        },
        resetWalkinForm(ctx, clientId = null) {
            ctx.commit('resetWalkinForm');
            if (clientId)
                this.dispatch('fetchModel', clientId);
        },
        unLock(ctx) {
            let clientId = ctx.state.currentModel.settings.clientId;
            axios.post(`${ctx.state.settingsApi}/${clientId}/un_lock`,
                {
                    TimeslotId: ctx.state.currentModel.availableTime.clientAvailableTimeId,
                    LockGuid: ctx.state.currentModel.availableTime.lockGuid
                })
                .then(response => {
                    console.log(response);
                });
        },
        resetOnlineForm(ctx) {
            ctx.commit('resetOnlineForm');
        },
        submitReservation(ctx, model) {
            //const delayTime = 30000;
            //alert("Added alert to test, Delay Time: " + delayTime);
            ctx.state.isLoading = true;
            ctx.state.isSubmitLoading = true;
            ctx.state.isTimePassed = false;
            ctx.state.isReservationSubmitted = true;

            ctx.state.previousRequestCancelToken = axios.CancelToken.source();
            const prmse = new Promise((resolve, reject) => {

                ctx.state.responseReceived = false;
                axios.post(`${ctx.state.settingsApi}/${model.clientId}`, model, { cancelToken: ctx.state.previousRequestCancelToken.token })
                    .then(response => {
                        ctx.state.isLoading = false;
                        ctx.state.isSubmitLoading = false;
                        ctx.state.responseReceived = true;
                        resolve(response);
                    })
                    .catch(error => {
                        ctx.state.responseReceived = true;
                        ctx.state.isError = true;

                        setTimeout(() => {
                            ctx.state.isLoading = false;
                            ctx.state.isSubmitLoading = false;
                            ctx.state.isError = false;
                            reject(error);
                        }, 10000);
                    });

                setTimeout(() => {
                    if (!ctx.state.responseReceived) {
                        ctx.state.isTimePassed = true;
                        setTimeout(() => {
                            if (!ctx.state.responseReceived) {
                                ctx.state.previousRequestCancelToken.cancel();
                                ctx.state.isError = true;

                                setTimeout(() => {
                                    ctx.state.isLoading = false;
                                    ctx.state.isSubmitLoading = false;
                                    ctx.state.isError = false;
                                    reject('Time Elapsed');
                                }, 8000); // Error message after 34 seconds, show for 13 seconds, then return to sign-in page
                            }
                        }, 100000); // Step2: From 4 seconds for 33 seconds, Show the be-patient message 
                    }
                }, 3000); // Step1: For 3 seconds, show the transmitting message
            });

            return prmse;
        },
        checkOnlineReservation(ctx, model) {
            ctx.state.isLoading = true;
            return new Promise((resolve, reject) => {
                axios.post(`${ctx.state.settingsApi}/${model.clientId}/online`, model)
                    .then(response => {
                        ctx.state.isLoading = false;
                        resolve(response);
                    })
                    .catch(error => { reject(error); });
            });
        },
        fetchOwnerDetails(ctx, data) {
            let clientId = ctx.state.currentModel.settings.clientId;
            ctx.state.loadingContacts = true;
            axios.get(`${ctx.state.settingsApi}/${clientId}/ezyvet_fetch_contacts?value=${data.value}`).then(r => {
                ctx.commit('updateEzyvetContacts', r.data);
            }).catch(error => {
                console.log(error);
            }).finally(() => ctx.state.loadingContacts = false);
        },
        fetchAnimals(ctx, input) {
            let clientId = ctx.state.currentModel.settings.clientId;
            axios.get(`${ctx.state.settingsApi}/${clientId}/ezyvet_fetch_animals?contactId=${input.contactId}`).then(r => {
                ctx.commit('updateEzyvetAnimals', r.data);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                ctx.state.loadingContacts = false;
                ctx.state.addNewAnimal = false;
            });
        }
    }
})